var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animated-dollar',{attrs:{"animation":_vm.animation,"number":_vm.number,"prefix":_vm.prefix,"increaseClass":_vm.increaseClass,"decreaseClass":_vm.decreaseClass}})}
var staticRenderFns = []

export { render, staticRenderFns }